import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// API仕様書_法人職員
// 加入登録手続き一覧参照API
import {
  IAPI_STA018_Request,
  IAPI_STA018_Response,
} from "../../../type/apiType";

// 加入登録手続き一覧参照API
const httpIAPI_STA018 = async (
  param: IAPI_STA018_Request
): Promise<IAPI_STA018_Response> => {
  let res = await http.post(ApiUrl.API_STA018, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_STA018 };
